import { useMediaQuery } from '@hover/blueprint/chakra';
import { breakpoints } from '@hover/blueprint/foundation';

const useIsMobileSize = (): boolean => {
  const isTablet = useMediaQuery(`(min-width: ${breakpoints?.tablet})`)[0];
  // Tablet is the next width above mobile, if it is not tablet, then it must
  // be mobile
  return !isTablet;
};

export { useIsMobileSize };
